// extracted by mini-css-extract-plugin
var _1 = "webpack-concepts-Extraction-Blocks-Heading-editor-HeadingEditor-module__container";
export { _1 as "container" }
